import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
declare let THREE: any;
declare let TWEEN: any;
import { EngineService } from '../services/engine.service';
import { CameraService } from '../services/camera.service';
import { RendererService } from '../services/renderer.service';
import { StageService } from '../services/stage.service';
import { ViewSwitcherService } from '../services/view-switcher.service';
import {OrbitService} from '../services/orbit.service';

@Component({
  selector: 'app-canvas-wrp',
  templateUrl: './canvas-wrp.component.html',
  styleUrls: ['./canvas-wrp.component.scss']
})
export class CanvasWrpComponent implements OnInit, AfterViewInit {

  @ViewChild('rendererContainer') rendererContainer: ElementRef;

  scene = null;
  camera = null;
  w = window.innerWidth - 316;
  h = window.innerHeight;

  directions = [
    new THREE.Vector2(0, 10),
    new THREE.Vector2(0, -10),
    new THREE.Vector2(-10, 0),
    new THREE.Vector2(10, 0)
  ];

  constructor(
    private cameraManager: CameraService,
    private engine: EngineService,
    private renderer: RendererService,
    private stage: StageService,
    private viewSwitcher: ViewSwitcherService,
    private orbitControl: OrbitService
  ) {
    this.animate = this.animate.bind(this);
  }

  onMoveCamera(index: number) {
    const dir = this.directions[index];
    this.orbitControl.pan(dir.x, dir.y);
  }

  ngAfterViewInit() {
    this.rendererContainer.nativeElement.appendChild(this.renderer.getCanvas());
    this.resizeToContainer();
    this.animate();
  }

  animate() {
    window.requestAnimationFrame(this.animate);
    this.renderer.render(this.stage.scene);
  }

  ngOnInit() {
    this.engine.attachCanvas(this.renderer.getCanvas());
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resizeToContainer();
  }

  private resizeToContainer() {
    if (!this.rendererContainer || !this.rendererContainer.nativeElement) {
      return;
    }
    const container = this.rendererContainer.nativeElement as HTMLElement;
    const width = Math.max(container.clientWidth, 1);
    const height = Math.max(container.clientHeight, 1);
    this.w = width;
    this.h = height;
    this.stage.setSize(width, height);
  }
}



// WEBPACK FOOTER //
// ./src/app/canvas-wrp/canvas-wrp.component.ts